const key = Symbol();
const ButtonColor = Object.freeze({
    RED: "RED",
});
const supportedColors = [ButtonColor.RED];
export { key, supportedColors, ButtonColor };
